if (!customElements.get('card-related-color-swatches')) {
  class CardRelatedColorSwatches extends HTMLElement {
    constructor() {
      super();
      this.setupRelatedProductSwatches();
    }

    setupRelatedProductSwatches() {
      this.cardWrapper = this.closest('.card-wrapper');
      this.swatches = this.querySelectorAll('.color-swatch[data-related-product-handle]');
      this.actionButton = this.querySelector('.color-swatch--action');
      this.outSwatches = this.querySelectorAll('.color-swatch[data-swatch-out]');

      if (this.actionButton) {
        this.actionButton.addEventListener('click', this.onActionClick.bind(this));
      }

      if (this.swatches.length > 0) {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.handleRelatedProductClick.bind(this));
        });
      }
    }

    onActionClick() {
      if (this.classList.contains('expanded')) {
        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('close-animation');
        });

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('close-animation');
          });
          this.classList.remove('expanded');
        }, 300);
      } else {
        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('open-animation');
        });

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('open-animation');
          });
          this.classList.add('expanded');
        }, 300);
      }
    }

    handleRelatedProductClick(event) {
      const clickedSwatch = event.currentTarget;
      const relatedProductHandle = clickedSwatch.dataset.relatedProductHandle;
      const variantId = clickedSwatch.dataset.variantId;
      const swatchColor = clickedSwatch.dataset.swatchColor;

      if (!relatedProductHandle) {
        return;
      }

      event.preventDefault();

      this.fetchAndUpdateCard(relatedProductHandle, variantId, swatchColor);
    }

    async fetchAndUpdateCard(handle, variantId, swatchColor) {
      if (!this.cardWrapper) {
        return;
      }

      try {
        const url = `/products/${handle}?variant=${variantId}&view=product-card`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();

        this.cardWrapper.innerHTML = html;

        this.reactivateSwatch(swatchColor);

        this.reinitializeComponents();

      } catch (error) {
        console.warn(`Failed to load related product ${handle}:`, error);
      }
    }

    reactivateSwatch(color) {
      if (!color) return;

      const newSwatchesContainer = this.cardWrapper.querySelector('card-related-color-swatches');
      if (!newSwatchesContainer) return;

      const allSwatches = newSwatchesContainer.querySelectorAll('.color-swatch');
      allSwatches.forEach(swatch => swatch.classList.remove('is-active'));

      const matchingSwatch = newSwatchesContainer.querySelector(`[data-swatch-color="${color}"]`);
      if (matchingSwatch) {
        matchingSwatch.classList.add('is-active');
      }
    }

    reinitializeComponents() {
      const mediaGallery = this.cardWrapper.querySelector('card-media-gallery');
      if (mediaGallery && typeof mediaGallery.connectedCallback === 'function') {
        mediaGallery.connectedCallback();
      }

      const quickAdd = this.cardWrapper.querySelector('card-quick-add');
      if (quickAdd && typeof quickAdd.connectedCallback === 'function') {
        quickAdd.connectedCallback();
      }

      const newSwatchesContainer = this.cardWrapper.querySelector('card-related-color-swatches');
      if (newSwatchesContainer && newSwatchesContainer !== this) {
        if (typeof newSwatchesContainer.setupRelatedProductSwatches === 'function') {
          newSwatchesContainer.setupRelatedProductSwatches();
        }
      }
    }
  }

  customElements.define('card-related-color-swatches', CardRelatedColorSwatches);
}
